import styled from 'styled-components'

import {
  Typography as OriginTypography,
  Link as LinkCommon,
  Button as CommonButton,
} from 'primsell-shared-layer/components'
import { baseTheme } from 'primsell-shared-layer/styles/theme'
import { LinkTypography } from '../../../primsell-shared-layer/components/atoms/link/link.styles'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 50%;
`

export const NFTInfo = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 24px;

  ${OriginTypography}:first-child {
    width: 60%;
    word-break: break-word;
  }
  ${OriginTypography}:last-child {
    margin-top: 5px;

    font-style: normal;
    font-size: 16px;
    line-height: 24px;
  }
`
export const NFTTitleTypography = styled(OriginTypography)`
  font-size: 24px;
  font-weight: 600;
  line-height: normal;
`

export const InStockTypography = styled(OriginTypography)`
  margin: 8px 0;

  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`

export const TotalPay = styled.div`
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`
export const TotalPayTypography = styled(OriginTypography)`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`

export const TitleTypography = styled(OriginTypography)`
  margin-bottom: 8px;
`

export const DescTypography = styled(OriginTypography)`
  margin-bottom: 12px;
`

export const InfoBlock = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 12px;
  margin-bottom: 12px;
`

export const Link = styled(LinkCommon)`
  ${LinkTypography} {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    color: rgb(107, 114, 128);
    text-decoration: underline;
  }
`

export const WalletData = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`
export const Typography = styled(OriginTypography)`
  display: inline;

  color: ${baseTheme.colors.dark100};
  font-size: 16px;
  font-weight: 500;
`

export const WalletLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const Button = styled(CommonButton)`
  @media screen and (max-width: 400px) {
    margin-left: 8px;
  }
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;

  span {
    color: #737272;
  }
`
export const BuyFormPaymentWrapper = styled.div`
  @media screen and (max-width: 560px), @media ${baseTheme.device.mobileL} {
    background: ${baseTheme.colors.white};
  }
`
export const TimerContainer = styled.div`
  @media ${baseTheme.device.tablet} {
    min-height: 130px;
  }
  @media screen and (min-width: 1199px) {
    min-height: 106px;
  }
`
